import { IconFilter16 } from '@warp-ds/icons/react/filter-16';
import { Button } from '@warp-ds/react/components/button';
import { connect } from 'react-redux';

import { SortButton } from '@/components/filters/SortButton';
import { ResultCount } from '@/components/resultList/components/ResultCount';
import type { ApiQueryParams, PaleState, PaleVertical, SortValue } from '@/interfaces';
import { actions as appStateActions } from '@/state/appStateActions';
import { actions as filterActions } from '@/state/filterActions';
import { fetchResults } from '@/state/resultActions';
import styles from './MobileTopBar.module.css';

export interface MobileTopBarProps {
    vertical: PaleVertical;
    numberOfOffers?: number;
    filtersOpen: boolean;
    openFilter: (filtersOpen: boolean) => void;
    sortOptions?: SortValue[];
    defaultSort: SortValue;
    selectedSort?: SortValue;
    changeSort: (newSort?: SortValue) => void;
    triggerFetch?: (queryParam?: ApiQueryParams) => void;
}

export const MobileTopBar = ({
    vertical,
    numberOfOffers,
    filtersOpen,
    openFilter,
    sortOptions,
    defaultSort,
    selectedSort,
    changeSort,
    triggerFetch,
}: MobileTopBarProps) => (
    <div className="md:hidden">
        <div className={`${styles.fixedMobileTopBar} p-16`} data-testid="mobileTopBar">
            <div className="flex justify-between items-center">
                <Button
                    primary={filtersOpen}
                    utility={!filtersOpen}
                    small
                    onClick={() => openFilter(!filtersOpen)}
                    aria-label={filtersOpen ? 'Vis resultat' : 'Vis filter'}
                    className="flex gap-8"
                    data-testid="showFilterButton">
                    <IconFilter16 />
                    {filtersOpen ? 'Resultat' : 'Filter'}
                </Button>
                <ResultCount numberOfOffers={numberOfOffers} vertical={vertical} />
                <SortButton
                    defaultValue={defaultSort}
                    selectedValue={selectedSort}
                    sortOptions={sortOptions}
                    changeSort={changeSort}
                    triggerFetch={triggerFetch}
                />
            </div>
        </div>
        <div className="mt-64" data-testid="fixedTopBarSpacer" />
    </div>
);

const mapStateToProps = (state: PaleState): Omit<MobileTopBarProps, 'openFilter' | 'changeSort' | 'triggerFetch'> => ({
    vertical: 'pp',
    numberOfOffers: state.results.numberOfHotels,
    filtersOpen: state.appState.filtersOpen,
    sortOptions: state.results.sortOptions,
    defaultSort: state.results.defaultSort,
    selectedSort: state.filters.sort,
});

export default connect(mapStateToProps, {
    openFilter: appStateActions.openFilter,
    changeSort: filterActions.changeSort,
    triggerFetch: fetchResults,
})(MobileTopBar);
